export class DeployModel{
  ArticleName: string;
  Environment: string;
  SystemName: string;
  constructor(ArticleName : string, Environment : string, SystemName : string) {
    this.ArticleName = ArticleName;
    this.Environment = Environment;
    this.SystemName = SystemName;
  }
}